var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleMissedVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8651 0.68659L1.42259 0.244078C1.09715 -0.0813593 0.569515 -0.0813593 0.244078 0.244078C-0.0813592 0.569515 -0.0813592 1.09715 0.244078 1.42259L2.16494 3.34346C1.00522 3.44843 0 4.35958 0 5.59524V12.7381C0 14.0527 1.13777 15 2.38889 15H10.9444C11.7128 15 12.4384 14.6427 12.884 14.0625L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4034 17.7751 18.4143 17.2725 18.1219 16.9453L1.89772 0.721092C1.88646 0.709828 1.87559 0.698322 1.8651 0.68659Z",
    fill: "#FF3A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1214 13.5877C17.2691 13.5458 17.411 13.4835 17.5427 13.4021C17.7843 13.2529 17.9837 13.0443 18.1221 12.7964C18.2605 12.5484 18.3332 12.2691 18.3333 11.9851V6.34803C18.3332 6.06404 18.2605 5.78436 18.1221 5.53637C17.9837 5.28837 17.7843 5.07985 17.5427 4.93059C17.3011 4.78133 17.0254 4.69627 16.7417 4.68349C16.458 4.67071 16.1757 4.73064 15.9217 4.85758L13.3333 6.15146V5.59524C13.3333 4.28064 12.1956 3.33333 10.9444 3.33333H6.86699L17.1214 13.5877Z",
    fill: "#FF3A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleMissedVideoCall);
export default __webpack_public_path__ + "static/media/people-missed-video-call.b0e4e882aee6e2131e928f61859717d2.svg";
export { ForwardRef as ReactComponent };